<i18n
  src="@/locales/views/agro_exporter/production/query_container_export/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-calendar-days"></i><span class="space-icon"></span>
      {{ $t("labels.schedule_title") }}
    </h1>
    <bimonthly-schedule :exportations="exportations" :containers="containers" :schedule="schedule"
      @update-schedule="updateSchedule" />
  </div>
</template>

<script>
import ShowProcessTabsMixin from "@/components/views/agro_exporter/production/query_container_export/show_process/show_process_tabs_mixin.js";
import BimonthlySchedule from "@/components/views/agro_exporter/production/shared/BimonthlySchedule.vue";

export default {
  name: "ShowProcessSchedule",
  mixins: [ShowProcessTabsMixin],
  components: { BimonthlySchedule },
  props: {
    schedule: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateSchedule: function (reference_month) {
      this.$emit('updateSchedule', reference_month);
    }
  },
  computed: {
    containers: function () {
      let containers = [];
      this.years.forEach(year => {
        const months = Object.keys(this.schedule[year]);
        months.forEach(month => {
          containers = [...containers, ...this.schedule[year][month].containers];
        });
      });
      return containers;
    },
    exportations: function () {
      let exportations = [];
      this.years.forEach(year => {
        const months = Object.keys(this.schedule[year]);
        months.forEach(month => {
          exportations = [...exportations, ...this.schedule[year][month].exportations];
        });
      });
      return exportations;
    },
    years: function () {
      return Object.keys(this.schedule);
    },
  },
};
</script>
